import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const SortModal = ({ isOpen, onClose, currentSort, onSelect }) => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === 'ar';

  const sortOptions = [
    { id: 'popular', label: isAr ? 'الأكثر شعبية' : 'Popular' },
    { id: 'verified', label: isAr ? 'موثق' : 'Verified' },
    { id: 'newest', label: isAr ? 'الأحدث إلى الأقدم' : 'Newest to Oldest' },
    { id: 'oldest', label: isAr ? 'الأقدم إلى الأحدث' : 'Oldest to Newest' },
    { id: 'price_high', label: isAr ? 'السعر من الأعلى للأقل' : 'Price Highest to Lowest' },
    { id: 'price_low', label: isAr ? 'السعر من الأقل للأعلى' : 'Price Lowest to Highest' },
    { id: 'km_high', label: isAr ? 'الكيلومترات من الأعلى للأقل' : 'Kilometers Highest to Lowest' },
    { id: 'km_low', label: isAr ? 'الكيلومترات من الأقل للأعلى' : 'Kilometers Lowest to Highest' },
    { id: 'year_high', label: isAr ? 'السنة من الأعلى للأقل' : 'Year Highest to Lowest' },
    { id: 'year_low', label: isAr ? 'السنة من الأقل للأعلى' : 'Year Lowest to Highest' },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-b from-[#1A1A2E] to-[#0F3460] rounded-t-2xl max-h-[70vh] overflow-hidden"
        onClick={e => e.stopPropagation()}>
        {/* Dark Header */}
        <div className="hero-gradient relative">
          <div className="noise-overlay" />
          <div className="px-4 py-4 relative z-10">
            <h2 className="font-bold text-white text-base text-center font-heading">
              {isAr ? 'ترتيب' : 'Sort By'}
            </h2>
          </div>
        </div>

        {/* Options */}
        <div className="overflow-y-auto max-h-[calc(70vh-60px)] p-3 space-y-1.5 mb-16">
          {sortOptions.map(option => (
            <button key={option.id}
              onClick={() => { onSelect(option.id); onClose(); }}
              className={`w-full flex items-center justify-between px-4 py-3.5 rounded-2xl transition-all active:scale-[0.98] ${
                currentSort === option.id
                  ? 'bg-[#E31C25] text-white shadow-lg shadow-[#E31C25]/20'
                  : 'bg-white/[0.04] text-white/60 border border-white/[0.06] hover:bg-white/[0.08]'
              }`}
              data-testid={`sort-${option.id}`}>
              <span className={`text-sm ${currentSort === option.id ? 'font-bold' : 'font-medium'}`}>{option.label}</span>
              {currentSort === option.id && <Check className="w-4 h-4 text-white" />}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SortModal;
